import { render, staticRenderFns } from "./crudInformation.vue?vue&type=template&id=31984a12"
import script from "./crudInformation.vue?vue&type=script&lang=js"
export * from "./crudInformation.vue?vue&type=script&lang=js"
import style0 from "./crudInformation.vue?vue&type=style&index=0&id=31984a12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports